import React from 'react';

const KhanjarBadge = () => {
  return (
    <div className="fixed bottom-3 right-3 md:bottom-6 md:right-6 z-[60]">
      <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg border border-gray-100 p-1.5 md:p-2.5 hover:shadow-2xl transition-all duration-500 hover:scale-110 group">
        <div className="flex items-center space-x-2">
          <img
            src="/assets/logo/khanjar.png"
            alt="Made in Oman"
            className="w-8 h-8 md:w-14 md:h-14 object-contain group-hover:scale-110 transition-transform duration-500"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default KhanjarBadge; 